import { render } from "./index.vue?vue&type=template&id=a6d488b0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a6d488b0&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BaseForm/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6d488b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6d488b0', __exports__)) {
    api.reload('a6d488b0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a6d488b0", () => {
    api.rerender('a6d488b0', render)
  })

}


export default __exports__